import {
    deleteAddOnCategory, deleteAddOnItem,
    deleteMenuCategory,
    deleteMenuItem, removeMenuItemAddOns, removeMenuItemTypeAddOns
} from "../api/menu";
import AddUpdateMenu from "@/components/restaurants/AddUpdateMenu.vue";

export default {
    name: "MenuValidation",
    methods: {
        confirmFromUserBeforeDeleting: async function (message) {
            return await Swal({
                title: 'Are you sure?',
                text: message,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#1ab394',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            });
        },
        confirmFromUserBeforeApplingDiscountOnAllMenuItem: async function (message) {
            return await Swal({
                title: 'Are you sure?',
                text: message,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#1ab394',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, apply it!'
            });
        },
        showMessageAfterDeletion: function(message, resId, resName, indexMenuItemType, object){
            swal("SUCCESS!", message, "success")
            if(resId === "" && resName === "") {
                AddUpdateMenu.methods.removeFromObject(indexMenuItemType, object)
            }else{
                this.$parent.removeFromObject(indexMenuItemType, object);
            }
        },
        showMessagesAccToResponse: function(response, indexMenuItemType, object, resId = "" , resName = "") {
            if (response.data.status === 200) {
                this.showMessageAfterDeletion(response.data.message, resId, resName, indexMenuItemType, object);
            }else if( response.data.status === 406){
                swal("ERROR!", response.data.message, "error");
            } else {
                this.showErrorMessage(response.data.message);
            }
        },
        deleteItem: async function (menuItem, menuItemServings, indexMenuItemType, object) {
            console.log("Deleting menu item!")
            let deleteItem = await this.confirmFromUserBeforeDeleting("Are You Sure You Want To Delete this Item?");
            if (deleteItem.value) {
                this.showLoading()
                let deleteMenuItemResp = await deleteMenuItem(menuItem).catch(ex => {
                        this.showErrorMessage(ex)
                    }
                );
                this.showMessagesAccToResponse(deleteMenuItemResp, indexMenuItemType, object);
            }
        },
        deleteMenuCategory: async function (categoryId, menuItems, indexMenuItemType, object) {
            if(menuItems.length > 0){
                swal("ERROR!", "You can't delete this menu category. Because it contain menu items!", "error");
                return;
            }
            console.log("Deleting menu category")
            let deleteCategory = await this.confirmFromUserBeforeDeleting("Are you sure you want to delete this menu category?")
            if (deleteCategory.value) {
                this.showLoading()
                let deleteMenuCategoryResp = await deleteMenuCategory(categoryId).catch(ex => {
                        this.showErrorMessage(ex)
                    }
                );
                this.showMessagesAccToResponse(deleteMenuCategoryResp, indexMenuItemType, object);
            }
        },
        deleteAddOnCategory: async function (addOnCategoryId, resId, resName, addOnItems, index, object) {
            console.log("==> ", addOnItems)
            if(addOnItems.length > 0){
                swal("ERROR!", "You can't delete this add-on category. Because it contain add items!", "error");
                return;
            }
            console.log("Deleting add on category")
            let deleteCategory = await this.confirmFromUserBeforeDeleting("Are you sure you want to delete this add-on category?")
            if (deleteCategory.value) {
                this.showLoading()
                let deleteAddOnCategoryResp = await deleteAddOnCategory(addOnCategoryId).catch(ex => {
                        this.showErrorMessage(ex)
                    }
                );
                this.showMessagesAccToResponse(deleteAddOnCategoryResp, index, object, resId, resName);
            }
        },
        deleteAddOnItem: async function (addOnItemId, resId, resName, index, object) {
            console.log("Deleting add on item")
            let deleteAddOn = await this.confirmFromUserBeforeDeleting("Are you sure you want to delete this add-on item?")
            if (deleteAddOn.value) {
                this.showLoading()
                let deleteAddOnItemResp = await deleteAddOnItem(addOnItemId).catch(ex => {
                        this.showErrorMessage(ex)
                    }
                );
                this.showMessagesAccToResponse(deleteAddOnItemResp, index, object,  resId, resName);
            }
        },
        removeAddOnWithMenuItem: async function (menuItemAddOnId, indexMenuItemType, object) {
            console.log("Deleting add on category")
            let deleteAddon = await this.confirmFromUserBeforeDeleting("Are you sure you want to remove this add-on category?")
            if (deleteAddon.value) {
                this.showLoading()
                let removeAddOnCategoryResp = await removeMenuItemAddOns(menuItemAddOnId).catch(ex => {
                        this.showErrorMessage(ex)
                    }
                );
                this.showMessagesAccToResponse(removeAddOnCategoryResp, indexMenuItemType, object);
            }
        },
        removeAddOnWithMenuItemType: async function (servingAddOnId, indexMenuItemType, object) {
            console.log("Deleting add on category")
            let deleteAddon = await this.confirmFromUserBeforeDeleting("Are you sure you want to remove this add-on category?")
            if (deleteAddon.value) {
                this.showLoading()
                let removeAddOnCategoryResp = await removeMenuItemTypeAddOns(servingAddOnId).catch(ex => {
                        this.showErrorMessage(ex)
                    }
                );
                this.showMessagesAccToResponse(removeAddOnCategoryResp, indexMenuItemType, object);
            }
        },
    }
}